import { GatewayType } from "@/constants";
import type {
  ActiveSubscriptionResponse,
  CheckoutSessionResponse,
  CustomerPortalResponse,
  UpdatePlanResponse,
} from "@/types/subscription";

import type { APIInstance } from "./apiService";

export class SubscriptionService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async createCheckoutSession(
    firmId: string,
    productPriceId: string
  ): Promise<CheckoutSessionResponse> {
    const response = await this.api.post<CheckoutSessionResponse>(
      `/firms/${firmId}/payments/purchase`,
      {
        product_purchase_id: productPriceId,
      }
    );
    return response.data;
  }

  async updatePlan(firmId: string, productPriceId: string): Promise<UpdatePlanResponse> {
    const response = await this.api.post<UpdatePlanResponse>(
      `/firms/${firmId}/payments/update-plan`,
      {
        product_purchase_id: productPriceId,
      }
    );
    return response.data;
  }

  async createCustomerPortalSession(
    firmId: string,
    gatewayType: GatewayType
  ): Promise<CustomerPortalResponse> {
    const response = await this.api.post<CustomerPortalResponse>(
      `/firms/${firmId}/billings/${gatewayType}/portal`
    );
    return response.data;
  }

  async getActiveSubscription(firmId: string): Promise<ActiveSubscriptionResponse> {
    const response = await this.api.get<ActiveSubscriptionResponse>(
      `/firms/${firmId}/subscriptions/active`
    );
    return response.data;
  }
}
